import { t } from "i18next";
import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

export const frameworkValueReminderFailure = (title: string, error: unknown) => ({
  title,
  description:
    isFetchBaseQueryError(error) && isApiErrorDto(error.data) ? t(error.data.errorCode) : t("Try again."),
  status: "error" as const,
  isClosable: true,
});
